module.exports = __webpack_public_path__ + "static/media/arrowup.1c005f83.svg";